import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSonarqubeComponent } from './simple-icons-sonarqube.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSonarqubeComponent ],
    exports:      [ SimpleIconsSonarqubeComponent ],
    bootstrap:    []
})
export class SimpleIconsSonarqubeModule {}
